module.exports = __webpack_public_path__ + "media/images/area/area_shigaM400-43b9d8c52a21f56e626baaff0f477d6f.jpg";